var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarHomeOn = function SvgNavbarHomeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "m13.058 2.56 7.189 7.19h.003V22.5H6.75a3 3 0 0 1-3-3V9.75h.003l7.184-7.189h-.001L11.997 1.5zM15 18H9v-1.5h6z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarHomeOn;